import { Events } from '@type-r/models';
import * as React from 'react';
import { getAppHref } from './common';


export const Link = ({
    href = undefined,
    disabled = false,
    children, 
    onClick = undefined, 
    anchor = undefined, 
    params = undefined, 
    returnUrl = false, 
    onMouseDown = undefined, 
    ...props
}) => {

    if (returnUrl) {
        params = { ...params, ...{ returnUrl: `${window.location.pathname}${window.location.search}` } }
    }

    let url = href;
    if (params) {
        url += "?" + new URLSearchParams(params)
    }

    return (
        <a href={url || '#'}
            {...props}
            onMouseDown={onMouseDown}
            onClick={e => {
                e.preventDefault();
                e.stopPropagation();

                if( disabled ) return false;

                onClick && onClick(e)
                href && Events.trigger('navigate', href, anchor, params);
            }}>
            {children}
        </a>
    )
}


export const AppLink = ({ href, children, ...rest }) => {
    const appHref = getAppHref(href);

    return (
        <Link href={appHref} {...rest}>
            {children}
        </Link>
    );
}